import { useMemo } from 'react'

import { Chip, ChipProps } from '@mui/material'
import { deepOrange } from '@mui/material/colors'

import { SearchDetailResult } from 'interface/search'
import { KojinResult } from 'interface/kojin'

type SenmoniChipsProps = {
  search: SearchDetailResult
  senmoni: KojinResult['senmoni']
} & ChipProps
export const SenmoniChips = ({
  search,
  senmoni,
  ...others
}: SenmoniChipsProps) => {
  const senmoniFlags = useMemo(
    () => {
      if (!senmoni) return null
      const searchSenmoniList = search.senmoni
      if (!searchSenmoniList || searchSenmoniList.length === 0) return null
      const isSearchsSenmoni = (senmoniCode: string) => searchSenmoniList.some(
        ss => ss.senmoniCode === '***' || ss.senmoniCode === senmoniCode
      )
      return senmoni.reduce(
        (flags, senmoni) => {
          if (isSearchsSenmoni(senmoni.senmoniCode)) {
            if (senmoni.sidoui) return { ...flags, sidoui: true }
            if (senmoni.senmoni) return { ...flags, senmoni: true }
            if (senmoni.ninteii) return { ...flags, ninteii: true }
          }
          return flags
        },
        { sidoui: false, senmoni: false, ninteii: false }
      )
    },
    [senmoni, search]
  )
  return senmoniFlags?.sidoui ? (
    <Chip {...others} variant="filled" color="warning" sx={{ bgcolor: deepOrange[900] }} label="指"/>
  ) : senmoniFlags?.senmoni ? (
    <Chip {...others} variant="filled" color="warning" sx={{ bgcolor: deepOrange[300] }} label="専"/>
  ) : senmoniFlags?.ninteii ? (
    <Chip {...others} variant="filled" color="warning" sx={{ bgcolor: deepOrange[100] }} label="認"/>
  ) : (
    <></>
  )
}
